import styles from './StateAttendance.module.css'
import ChatBubbleIcon from '@mui/icons-material/ChatBubble'
import HourglassTopIcon from '@mui/icons-material/HourglassTop'
import { Avatar, Box, Button, Chip, IconButton, Modal, TextField, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useClient } from '../../../../contexts/ClientContext'
import { red } from '@mui/material/colors'
import { useEffect, useState } from 'react'
import { Atendimento } from '@/interfaces/AttendanceData'
import { propostaApi } from '@/services/api/proposta'
import EditIcon from '@mui/icons-material/Edit';
import attendanceApi from '@/services/api/attendance'
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import { CheckRounded} from '@mui/icons-material'


interface StateAttendanceProps {
  id: number
  titulo?: string
  attendant: string
  date: string
  days?: string | Date
  estado: Atendimento['estado']
  statusDoEstado?: Atendimento['estado']
  onAlternar?: (active: boolean) => void
  onEstadoChange?: (novoEstado: Atendimento['estado']) => void
  ativo : boolean
  arquivado? : boolean
  onArquivarChange?: (arquivado: boolean) => void;
}

export function StateAttendance({
  id,
  titulo: tituloProp,
  attendant,
  date,
  days,
  estado,
  statusDoEstado,
  onAlternar,
  onEstadoChange,
  ativo,
  arquivado,
  onArquivarChange,
}: StateAttendanceProps) {
  const [alternar, setAlternar] = useState<boolean>(ativo)
  const { client } = useClient()
  const chatLink = client?.chatLink
  const [estadoAtual, setEstadoAtual] =
    useState<Atendimento['estado']>('Briefing')
  const [estadoProposta, setEstadoProposta] = useState<string | null>(null);
  const [modalAberto, setModalAberto] = useState<boolean>(false);
  const [tituloAtual, setTituloAtual] = useState<string>(tituloProp || '');
  const [erroNovoTitulo, setErroNovoTitulo] = useState<boolean>(false);


  const abrirModalAtualizarTitulo = () => {
    setModalAberto(true);
  };

  const clientContext = useClient()

  const [estadoArquivado, setEstadoArquivado] = useState<boolean>(arquivado || false)

  const fecharModal = () => {
    setModalAberto(false);
  };

  const salvarTitulo = async () => {
    try {
      const atendimento = await attendanceApi.atualizarTituloAtendimento(String(id), tituloAtual);
      if (atendimento.status === 200) {
        setTituloAtual(atendimento.data.titulo);
        fecharModal();
      } else {
        setErroNovoTitulo(true);
      }
    } catch (error) {
      console.error('Erro ao atualizar título:', error);
      setErroNovoTitulo(true);
    }
  };

  function alternarPropagacao() {
    setAlternar(!alternar)
    if (onAlternar) {
      onAlternar(alternar)
    }
  }

  async function alternarEstado(fase: Atendimento) {
    setEstadoAtual(fase.estado)
    onEstadoChange?.(fase.estado)
    verificaEstadoProposta()
  }

  async function verificaEstadoProposta() {
    try {
      const resposta = await propostaApi.buscarPropostaPorAtendimento(id)
      setEstadoProposta(resposta.data.estado_pagamento);
      return resposta.data.estado_pagamento;
    } catch (err) {
      console.error(err)
      setEstadoProposta(null)
    }
  }

  async function arquivar(id?: number) {
    try {
      if (estadoArquivado) {
        await attendanceApi.atualizarArquivamento(id, false)
      } else {
        await attendanceApi.atualizarArquivamento(id, true)
      }
      clientContext.reloadClientes()
      setEstadoArquivado(!estadoArquivado)
      onArquivarChange?.(!estadoArquivado);
    } catch (err) {
      console.error('Erro ao arquivar')
    }
  }

  useEffect(() => {
    verificaEstadoProposta();
  }, [id]);


  useEffect(() => {
    if (estado === 'Venda Concluída') {
      setEstadoAtual('Feedback');
    } else if (['Medição', 'Projeto Técnico', 'Produção'].includes(estado)) {
      setEstadoAtual('Produção');
    } else if(['Montagem'].includes(estado)) {
      setEstadoAtual('Montagem');
    } else {
      setEstadoAtual(estado);
    }
  }, [estado])


  useEffect(() => {
    setTituloAtual(tituloProp || '');
  }, [tituloProp]);

  useEffect(() => {
    setAlternar(ativo)
    console.log("Ativo", ativo)
  }, [ativo])

  useEffect(() => {
    setEstadoArquivado(arquivado || false)
  }, [arquivado])

  console.log('estado', estado, 'statusEstado', statusDoEstado)

  const [propostaPaga, setPropostaPaga] = useState<boolean>(false)

  useEffect(() => {
    isPropostaPaga()
  }, [])

  const isPropostaPaga = () => {
    return propostaApi.getPropostaAtiva(id.toString()).then((res) => {
      if(res?.data?.estado_pagamento === 'PAGAMENTO_CONFIRMADO') {
        setPropostaPaga(true)
      }
    })
  }

  const fases = [
    { label: 'Briefing', value: 'Briefing' },
    { label: 'Proposta', value: 'Proposta' },
    { label: 'Produção/Entrega', value: 'Produção' },
    { label: 'Montagem', value: 'Montagem' },
    { label: 'Feedback', value: 'Feedback' },
  ]  

  return (
    <>
      <Modal
        open={modalAberto}
        onClose={fecharModal}
        aria-labelledby="modal-atualizar-titulo"
        aria-describedby="modal-para-atualizar-o-titulo-do-atendimento"
      >
        <Box className={styles.modalStyle}>
          <Typography id="modal-atualizar-titulo" variant="h6" component="h2" gutterBottom>
            Atualizar Título
          </Typography>
          <TextField
            fullWidth
            label="Novo Título"
            value={tituloAtual}
            onChange={(e) => setTituloAtual(e.target.value)}
            sx={{ mb: 2, mt: 2 }}
            inputProps={{
              maxLength: 120,
            }}
          />
          {erroNovoTitulo && (
              <Typography variant="body2" color="error" gutterBottom>
                Erro ao atualizar título.
              </Typography>
            )}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Button variant="outlined" onClick={fecharModal}>
              Cancelar
            </Button>
            <Button variant="contained" onClick={salvarTitulo}>
              Salvar
            </Button>
          </Box>
        </Box>
      </Modal>

      <div className={styles.container_header}>
        <div className={styles.avatar_and_title}>
          <Avatar className='avatar-background'>
            <SupportAgentIcon />
          </Avatar>
          <div className={styles.title_component}>
            <h4>{tituloAtual ? tituloAtual : 'Atendimento - ' + id + `${estadoArquivado ? ' (Arquivado)' : ''}`}</h4>
            <EditIcon className={styles.edit_icon} onClick={abrirModalAtualizarTitulo} />
            <Inventory2OutlinedIcon onClick={() => arquivar(id)} className={styles.arquivar_icon} /> 
          </div>
        </div>
        <IconButton
          disableFocusRipple={true}
          onClick={alternarPropagacao}
          className={styles.icon_for_close}
        >
          {alternar ? (
            <ExpandLessIcon fontSize='large' />
          ) : (
            <ExpandMoreIcon fontSize='large' />
          )}
        </IconButton>
      </div>

      <div className={styles.container_main}>
        <div className={styles.container_attendance}>
          <div className={styles.date_attendance}>
            <span>Data e Hora</span>
            <span>{date}</span>
          </div>

          <div className={styles.state_attendance}>
            <div className={styles.chat_and_state}>
              {chatLink ? (
                <a
                  href={chatLink}
                  target='_blank'
                  rel='noopener noreferrer'
                  className={styles.chat_link}
                >
                  <div className={styles.chat_icon_with_text}>
                    <ChatBubbleIcon className={styles.icon_active} />
                    <span className={styles.chat_text}>on</span>
                  </div>
                </a>
              ) : (
                <ChatBubbleIcon className={styles.icon_disabled} />
              )}
              <Chip label={statusDoEstado} color='primary' className='list-item-chip' />
            </div>
            <div className={styles.time_and_day}>
              {statusDoEstado === 'Venda Concluída' ? (
                <CheckCircleIcon style={{ color: 'var(--checked)' }} />
              ) : (
                <HourglassTopIcon />
              )}
              <p className='dias'>{`${days}`}</p>
            </div>
          </div>

          <div className={styles.container_inform_attendant}>
            <Avatar sx={{ color: red[500] }} className='list-item-avatar'>
              <h4 className='letter-name-user'>{attendant.charAt(0)}</h4>
            </Avatar>
            <div className={styles.data_attendant}>
              <span>Atendente</span>
              <span>{attendant}</span>
            </div>
          </div>
        </div>
      </div>

      {
        alternar && (
          <div className={styles.container_estado_briefing}>
            <div className={styles.abas}>
              {fases.map(({ label, value }, index) => {
                const isDisabled = (value === 'Produção' && estadoProposta !== 'PAGAMENTO_CONFIRMADO') ||
                  (value === 'Montagem' && !['Produção', 'Montagem', 'Feedback', 'Venda Concluída'].includes(statusDoEstado ?? '')) ||
                  (value === 'Feedback' && !['Feedback', 'Montagem', 'Venda Concluída'].includes(statusDoEstado ?? ''))                

                return (
                  <div
                    key={index}
                    onClick={() => {
                      if (!isDisabled) {
                        alternarEstado({ estado: value } as Atendimento);
                      } else if (value === 'Produção') {
                        propostaApi.buscarPropostaPorAtendimento(id)
                          .then(res => {
                            if (res.data.estado_pagamento === 'PAGAMENTO_CONFIRMADO') {
                              setEstadoAtual('Produção')
                              onEstadoChange?.('Produção')
                            }
                          })
                          .catch(err => {
                            console.error('Erro ao verificar estado da proposta:', err);
                          })
                      }
                    }}                      
                    className={`${styles.aba} 
                      ${estadoAtual === value ? styles.aba_selecionada : ''} 
                      ${
                        statusDoEstado === 'Proposta' && value === 'Briefing' ? styles.abaCinza :
                        propostaPaga && (value === 'Proposta' || value === 'Briefing') ? styles.abaCinza :
                        ['Montagem', 'Realizou Montagem', 'Feedback', 'Venda Concluída'].includes(statusDoEstado ?? '') && value === 'Produção' ? styles.abaCinza :
                        ['Feedback', 'Venda Concluída'].includes(statusDoEstado ?? '') && value === 'Montagem' ? styles.abaCinza :
                        statusDoEstado === 'Venda Concluída' && value === 'Feedback' ? styles.abaCinza :
                        ''
                      }`}
                    style={{
                      borderBottom: estadoAtual === value ? '1px solid white' : 'none',
                    }}
                  >
                    <span className={styles.estado_atual}>
                      <div className={styles.propostaCheck}>
                        {label}
                        {value === "Proposta" && propostaPaga ? <CheckRounded style={{ height: "1.25rem" }} /> : ''}
                      </div>
                    </span>
                  </div>
                )
              })}

            </div>
          </div>
        )
      }
    </>
  )
}

